import { render } from "./DocWizard.vue?vue&type=template&id=266976b2&scoped=true"
import script from "./DocWizard.vue?vue&type=script&lang=js"
export * from "./DocWizard.vue?vue&type=script&lang=js"

import "./DocWizard.vue?vue&type=style&index=0&id=266976b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266976b2"]])

export default __exports__